// Converted to ARGB format (AARRGGBB) for Excel
const COLORS = {
  WHITE: "FFFFFFFF", // --du-color-white: #fff
  LIGHT_GRAY: "FFE1E1E1", // --du-color-grey-light: #e1e1e1
  TEAL: "FF007672", // --du-color-primary-aquamarine: #007672 (or du-color-hover)
};

// Border style used across all cells in the report
export const BORDER_STYLE = {
  top: { style: "thin", color: { argb: COLORS.LIGHT_GRAY } },
  left: { style: "thin", color: { argb: COLORS.LIGHT_GRAY } },
  bottom: { style: "thin", color: { argb: COLORS.LIGHT_GRAY } },
  right: { style: "thin", color: { argb: COLORS.LIGHT_GRAY } },
};

// Base header style (size 11, bold, white text on teal background)
const BASE_HEADER_STYLE = {
  font: { bold: true, color: { argb: COLORS.WHITE }, size: 11 },
  fill: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: COLORS.TEAL },
  },
};

// Base subheader style (size 10, bold, white text on teal background)
const BASE_SUBHEADER_STYLE = {
  font: { bold: true, color: { argb: COLORS.WHITE }, size: 10 },
  fill: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: COLORS.TEAL },
  },
};

// Base center alignment with text wrapping
const CENTER_ALIGNED = {
  horizontal: "center",
  vertical: "center",
};
const CENTER_ALIGNED_WRAP = {
  horizontal: "center",
  vertical: "center",
  wrapText: true,
};

// styles for headers, subheaders, and data cells
export const HEADER_STYLE = {
  ...BASE_HEADER_STYLE,
  alignment: CENTER_ALIGNED_WRAP,
};

export const SUBHEADER_STYLE = {
  ...BASE_SUBHEADER_STYLE,
  alignment: CENTER_ALIGNED_WRAP,
};

export const DATA_STYLE = {
  alignment: CENTER_ALIGNED,
};
